// Styled AppBar Component - Berry theme style

import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';

// Full-width fixed AppBar (Berry style)
const AppBarStyled = styled(MuiAppBar)(({ theme }) => ({
  position: 'fixed',
  width: '100%',
  zIndex: theme.zIndex.drawer + 1,
  borderRadius: '0 !important',
  borderTopLeftRadius: '0 !important',
  borderTopRightRadius: '0 !important',
  borderBottomLeftRadius: '0 !important',
  borderBottomRightRadius: '0 !important',
  overflow: 'visible',
  '& *:not(.MuiButton-root):not(.MuiIconButton-root)': {
    borderRadius: '0 !important'
  }
}));

export default AppBarStyled;
